<!-- planning dialog -->
<dx-popup
  width="500px"
  height="700px"
  [showTitle]="true"
  [title]="'PROJECT_PLANNING.TITLE' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [visible]="visible()"
  [shading]="true"
  [contentTemplate]="'content'">
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="top"
    location="after"
    [options]="{ icon: 'close', onClick: closePlanningDialog.bind(this) }">
  </dxi-toolbar-item>
  <dxo-position boundaryOffset="0 200" at="top" [of]="'#right-col'" collision="fit"> </dxo-position>

  <div *dxTemplate="let data of 'content'">
    @if (currentPlanning(); as planning) {
      <div class="add-assignment">
        <div>
          <div class="planning-info">
            <span>{{ 'PROJECT_PLANNING.ASSIGNMENT_TOTAL' | translate }}:</span>
            <span>{{ planning.dispoVolume() | number: '1.1-1' }} m³</span>
            <span> {{ planning.dispoWeight() | number: '1.1-1' }} t </span>

            @if (projectAdrPointsTotal() > 0) {
              <app-badge-variant
                [shape]="Shape.Hexagon"
                badge="none"
                [label]="projectAdrPointsTotal()"
                backgroundColor="#f97316"></app-badge-variant>
            }
          </div>
          <div class="planning-info">
            <span>{{ 'PROJECT_PLANNING.UNPLANNED' | translate }}:</span>
            <span>{{ planning.unplannedVolume() | number: '1.1-1' }} m³</span>
            <span> {{ planning.unplannedWeight() | number: '1.1-1' }} t </span>
          </div>
        </div>

        <hr />

        <!-- truck -->
        <div class="planning-info">
          <span>{{ 'PROJECT_PLANNING.TRUCK' | translate }}:</span>
          <span class="info">{{ planning.truck.loadUnitSlot?.loadUnitContainer?.name }}</span>
          <em>{{ planning.truck.overload() ? ('PROJECT_PLANNING.OVERLOAD' | translate) : '' }}</em>
        </div>

        <div id="truck-distribution">
          <div class="planning-info">
            <span>{{ 'PROJECT_PLANNING.CAPACITY' | translate }}:</span>
            <span>{{ planning.truck.volumeCapacity() | number: '1.1-1' }} m³</span>
            <span> {{ planning.truck.weightCapacity() | number: '1.1-1' }} t </span>
          </div>
          <div class="planning-info">
            <span>{{ 'PROJECT_PLANNING.CARGOLOAD' | translate }}:</span>
            <span>{{ planning.truck.volumeLoad() | number: '1.1-1' }} m³</span>
            <span> {{ planning.truck.weightLoad() | number: '1.1-1' }} t </span>
          </div>
          <br />

          <div class="distribution">
            <div class="distribution-inputs">
              <dx-number-box
                [(value)]="planning.truck.plannedVolume"
                [min]="0"
                [max]="planning.truck.maxVolume()"
                [showSpinButtons]="true"
                [showClearButton]="true"
                (onValueChanged)="planning.updateTruckWeight($event)"
                [label]="'PROJECT.CurrentVolume' | translate">
                <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
              </dx-number-box>
              <dx-number-box
                [(value)]="planning.truck.plannedWeight"
                [min]="0"
                [max]="planning.truck.maxWeight()"
                [showSpinButtons]="true"
                [showClearButton]="true"
                (onValueChanged)="planning.updateTruckVolume($event)"
                [label]="'PROJECT.CurrentWeight' | translate">
                <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
              </dx-number-box>
            </div>

            <div class="distribution-buttons">
              <dx-button
                [text]="'PROJECT_PLANNING.FILL' | translate"
                (onClick)="planning.fillTruck_3DotDialog()"></dx-button>
            </div>
          </div>
          <br />
          <div [class]="planning.truck.overload() ? 'progress overload-bar' : 'progress'">
            <div
              class="progress-bar"
              [style]="'width:' + planning.truck.occupiedCapacity() + '%'"
              style="background-color: rgb(18, 90, 158)"></div>
            <div
              class="progress-bar"
              [style]="'width:' + planning.truck.plannedCapacity() + '%'"
              style="background-color: #49a2eb"></div>
          </div>
        </div>

        <hr />

        <!-- trailer -->
        @if (planning.trailer.loadUnitSlot) {
          <div class="planning-info">
            <span>{{ 'PROJECT_PLANNING.TRAILER' | translate }}:</span>
            <span class="info">{{ planning.trailer.loadUnitSlot.loadUnitContainer.name }}</span>
            <em class="overload">{{ planning.trailer.overload() ? ('PROJECT_PLANNING.OVERLOAD' | translate) : '' }}</em>
          </div>

          <div id="trailer-distribution">
            <div class="planning-info">
              <span>{{ 'PROJECT_PLANNING.CAPACITY' | translate }}:</span>
              <span>{{ planning.trailer.volumeCapacity() | number: '1.1-1' }} m³</span>
              <span> {{ planning.trailer.weightCapacity() | number: '1.1-1' }} t </span>
            </div>
            <div class="planning-info">
              <span>{{ 'PROJECT_PLANNING.CARGOLOAD' | translate }}:</span>
              <span>{{ planning.trailer.volumeLoad() | number: '1.1-1' }} m³</span>
              <span> {{ planning.trailer.weightLoad() | number: '1.1-1' }} t </span>
            </div>
            <br />

            <div class="distribution">
              <div class="distribution-inputs">
                <dx-number-box
                  [(value)]="planning.trailer.plannedVolume"
                  [min]="0"
                  [max]="planning.trailer.maxVolume()"
                  [showSpinButtons]="true"
                  [showClearButton]="true"
                  (onValueChanged)="planning.updateTrailerWeight($event)"
                  [label]="'PROJECT.CurrentVolume' | translate">
                  <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
                </dx-number-box>
                <dx-number-box
                  [(value)]="planning.trailer.plannedWeight"
                  [min]="0"
                  [max]="planning.trailer.maxWeight()"
                  [showSpinButtons]="true"
                  [showClearButton]="true"
                  (onValueChanged)="planning.updateTrailerVolume($event)"
                  [label]="'PROJECT.CurrentWeight' | translate">
                  <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
                </dx-number-box>
              </div>

              <div class="distribution-buttons">
                <dx-button
                  [text]="'PROJECT_PLANNING.FILL' | translate"
                  (onClick)="planning.fillTrailer_3DotDialog()"></dx-button>
              </div>
            </div>
            <br />
            <div [class]="planning.trailer.overload() ? 'progress overload' : 'progress'">
              <div
                class="progress-bar"
                [style]="'width:' + planning.trailer.occupiedCapacity() + '%'"
                style="background-color: rgb(18, 90, 158)"></div>
              <div
                class="progress-bar"
                [style]="'width:' + planning.trailer.plannedCapacity() + '%'"
                style="background-color: #49a2eb"></div>
            </div>
          </div>

          <br />
        }

        <dx-button
          class="planning-dialog-button"
          [text]="finishText() | translate"
          (onClick)="executeCurrentPlanning()"></dx-button>
        <dx-button
          class="planning-dialog-button"
          [text]="'PROJECT_PLANNING.CANCEL' | translate"
          (onClick)="closePlanningDialog()"></dx-button>
      </div>
    } @else {
      <div class="add-assignment">
        <span>{{ 'PROJECT_PLANNING.NO_PLANNING' | translate }}</span>
      </div>
    }
  </div>
</dx-popup>
